/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  const selector$c = {
    // showcaseButton: "data-product-showcase",
    variantJSON: "[data-variant-json]",
    showcaseContainer: "product-showcase",
  };

  const attributes$c = {
    productData: "product-id",
  };

  class ProductShowcase extends HTMLElement {
    constructor() {
      super();
      this.container = this;

      // ? Lee el contenido JSON sin sobrescribir referencia
      this.variantData = JSON.parse(
        this.container.querySelector("[data-variant-json]").textContent,
      );

      // ? Usa el atributo correcto
      this.currentVariantId = this.container.getAttribute("variant-id");

      // ? Escucha cambios
      document.addEventListener(
        "theme:variant:change",
        this.handleVariantChange,
      );
    }

    handleVariantChange = (event) => {
      const newVariant = event.detail.variant;
      if (!newVariant || String(newVariant.id) === this.currentVariantId)
        return;

      this.currentVariantId = String(newVariant.id);
      const matchedVariant = this.variantData[this.currentVariantId];

      // ?? Si no hay strain, oculta todo el showcase

      if (matchedVariant.strain === null) {
        this.container.style.display = "none";
        return;
      } else {
        this.container.style.removeProperty("display");
      }

      // Actualiza el texto del t�tulo
      const showcaseTitle = this.container.querySelector(
        ".product-showcase__title",
      );
      if (showcaseTitle) showcaseTitle.innerText = matchedVariant.strain;

      // Actualiza im�genes de los efectos
      const effectImages = this.container.querySelectorAll(
        ".product-showcase__effect-image-img",
      );
      const effectCaptions = this.container.querySelectorAll(
        ".product-showcase__effect-image-caption",
      );

      if (effectImages.length >= 3 && matchedVariant.efectos_sellos) {
        const fixURL = (url) => url?.replace("https//", "https://") || "";
        effectImages[0].src = fixURL(matchedVariant.efectos_sellos.efecto_1);
        effectImages[1].src = fixURL(matchedVariant.efectos_sellos.efecto_2);
        effectImages[2].src = fixURL(matchedVariant.efectos_sellos.efecto_3);
      }

      if (effectCaptions.length >= 3 && matchedVariant.efectos) {
        effectCaptions[0].innerText = matchedVariant.efectos[0] || "";
        effectCaptions[1].innerText = matchedVariant.efectos[1] || "";
        effectCaptions[2].innerText = matchedVariant.efectos[2] || "";
      }
    };
  }

  if (!customElements.get("product-showcase")) {
    customElements.define("product-showcase", ProductShowcase);
  }
  // TODO: Hacer un nuevo constructor con un status para el zipCode
  // Usar el dataset para seleccionar todos los elementos involucrados
  // data-variant-location
  //
  // const selectors$1l = {
  //   announcementBar = '';
  //   headerBar = '',
  //   globalPopup = '',
  //   miniPopup = '',
  // };
  //
  // const attributes$1l = {
  //   target = 'data-variant-location',
  // };
  //
  // const clasess = {
  //   active = 'zipcode--active',
  //   deactive = 'zipcode--deactive',
  // };
  //
  // class ProductLocation extendds HTMLElement {
  //   constructor() {
  //
  //     super();
  //     this.containers = document.querySelectorAll('[data-variant-location]');
  //     this.announcement = document.querySelector();
  //   }
  // }
  //

  const selector$1l = {
    set: "[data-variant-location]",
  };

  const attributes$1l = {
    target: "data-variant-location",
  };

  const classes$1l = {
    active: "zipcode--active",
    deactive: "zipcode--deactive",
  };

  const sections$1l = {};

  class VariantLocation extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.zipCodeElements = this.container.querySelectorAll("input");
    this.zipValue = "";
    this.changeButton = this.container.querySelector(
      "[data-zip-change-button]",
    );
    this.zipAnnouncement = document.querySelector(".variant-location--input");
    this.locationAlreadySet = false;
  }

  connectedCallback() {
    this.init();
    this.syncInputs();
  }

  init = () => {
    const storedZip = localStorage.getItem("userZipCode");
    const dialog = this.querySelector("dialog");

    if (storedZip && /^\d{5}$/.test(storedZip)) {
      this.zipValue = storedZip;
      this.getLocationFromZip();

      this.zipCodeElements.forEach((input) => {
        input.value = "";
        input.placeholder = `C.P: ${storedZip}`;
      });

      this.container.setAttribute("data-cp-entered", "true");
      this.changeButton?.style?.setProperty("display", "inline-block");

      if (dialog) {
        dialog.removeAttribute("open");
        dialog.setAttribute("data-variant-location", "true");
        dialog.setAttribute("aria-hidden", "true");
      }
    } else {
      if (dialog) {
        dialog.setAttribute("open", "");
        dialog.removeAttribute("aria-hidden");
        dialog.removeAttribute("inert");
      }
    }
  };

  syncInputs = () => {
    this.zipCodeElements.forEach((input) => {
      input.addEventListener("input", ({ target }) => {
        const newValue = target.value;
        this.zipValue = newValue;

        this.zipCodeElements.forEach((el) => {
          if (el !== target) {
            el.placeholder = newValue;
          }
        });

        if (this.zipAnnouncement) {
          this.zipAnnouncement.placeholder = `C.P: ${newValue}`;
        }
      });

      input.addEventListener("change", ({ target }) => {
        const rawZip = target.value.trim();
        this.handleZipValueConfirmed(rawZip);
      });
    });
  };

  handleZipValueConfirmed = (rawZip) => {
    const closeButton = this.container.querySelector("[data-popup-close]");
    const sendButton = this.container.querySelector(
      ".variant-location__send-button",
    );
    const dialog = this.querySelector("dialog");

    if (rawZip.toLowerCase().startsWith("c.p")) return;

    if (/^\d{5}$/.test(rawZip)) {
      this.zipValue = rawZip;
      localStorage.setItem("userZipCode", rawZip);
      localStorage.setItem("zipFlag", "true");

      // 👉 primero setea location correctamente
      this.getLocationFromZip();

      // 👉 opcional: recargar después
      setTimeout(() => {
        location.reload();
      }, 300);

      this.zipCodeElements.forEach((input) => {
        input.value = "";
        input.placeholder = `C.P: ${rawZip}`;
      });

      this.changeButton?.style?.setProperty("display", "inline-block");
      this.container.setAttribute("data-cp-entered", "true");

      if (dialog) {
        dialog.setAttribute("data-variant-location", "true");
      }

      if (closeButton && sendButton) {
        closeButton.style.display = "flex";
        closeButton.click();
        sendButton.setAttribute("data-popup-close", "");
      }
    } else {
      alert("Ingresa un código postal válido de 5 dígitos.");
    }
  };

  // 🔥 FUNCIÓN SEGURA
  selectLocationSafe = (locationId, retries = 20) => {
    if (this.locationAlreadySet) return;

    if (
      window.inventoryInfo &&
      window.inventoryInfo.api &&
      typeof window.inventoryInfo.api.selectLocation === "function"
    ) {
      window.inventoryInfo.api.selectLocation(locationId);
      this.locationAlreadySet = true;

      console.log(`✅ Location seteada: ${locationId}`);
    } else if (retries > 0) {
      setTimeout(() => {
        this.selectLocationSafe(locationId, retries - 1);
      }, 150);
    } else {
      console.error("❌ selectLocation nunca estuvo disponible");
    }
  };

  getLocationFromZip = () => {
    const zip = parseInt(this.zipValue.trim(), 10);
    if (isNaN(zip)) return;

        const extraGuadalajaraZips = new Set([
            64170,66600,66056,66000,66650,67300,67123,67250,64710,66100,67500,67350,64000,
            36100,36300,36436,47527,36200,36700,38260,38360,38000,36970,36960,36000,36500,
            38400,38800,58500,38940,38980,58840,38900,58520,58900,76008,76146,76146,76800,
            76500,76270,76093,76240,76950,76700,37980,76000,76750,76650,38500,37729,38943,
            37950,76680,61100,61250,61500,61420,61280,58312,61421,61211,58000,61600,58420,
            58526,61800,61820,58331,58480,59920,58880,59460,61300,58970,58920,45965,58341,
            61650,61252,61080,61674,60175,61658,61659,60150,60490,60460,60443,60280,60270,
            60250,60290,60300,60440,59972,60394,60447,60400,60404,60443,60760,61278,60500,
            60521,60540,60865,61760,61790,61794,61763,61769,61730,61734,60780,61770,61750,
            61830,61840,61745,61735,61850,61860,61868,61793,60920,60980,60886,60990,60985,
            60985,60982,60982,60886,60886,60987,60987,60985,60950,60955,60985,60990,60990,
            60990,58760,58570,58600,59430,59300,59230,59250,59730,59780,59740,59987,59980,
            59920,59960,59930,59010,59510,59580,59500,59711,59550,59653,59613,59120,59200,
            59833,59180,58701,59750,47900,59716,60619,36910,47880,58400,41614,41615,41615,
            40881,40883,40138,40123,40880,41614,40850,40835,40831,40831,40882,40888,40880,
            40888,40880,40900,40910,40900,49657,40894,40903,40908,40905,40983,40904,40904,
            46570,40906,40905,40914,40966,40930,45066,40025,44330,40904,40912,40936,40935,
            40937,40932,40960,40934,39300,39380,39340,39380,39403,39390,39406,39897,39670,
            39760,39770,39800,39867,39890,39799,39715,39750,39713,39905,39810,39936,39990,
            39360,39940,39960,39120,40970,39097,44210,45680,45640,45500,45400,20920,20000,
            20300,20670,20400,20460,20700,20320,20800,1239,2010,3000,4000,5000,6140,8900,
            9430,10500,44760,13300,14000,30200,16070,52900,55700,54700,56330,55000,56530,
            11610,56343,54600,54009,54960,54900,54700,55640,52760,64330,42000, 42004, 42010,
            42014, 42015, 42018, 42020, 42026, 42027, 42029, 42030, 42032, 42033, 42034, 42035,
            42036, 42037, 42039, 42040, 42050, 42055, 42056, 42057, 42058, 42060, 42064, 42070,
            42075, 42078, 42079, 42080, 42082, 42083
        ]);

      const locationMappings = [
        { id: "69200904446",
          ranges: [
            // { from: 44009, to: 45696 },
            { from: 44100, to: 45249 },
            { from: 45400, to: 45429 },
            { from: 45500, to: 45679 },
            { from: 49000, to: 49113 },
          ]
        }, // Guadalajara 44100 - 44250
        {
          id: "78100529406", // Tepic
          ranges: [
            { from: 63000, to: 63529 },
            { from: 63780, to: 63799 },
          ],
        },
      ];

      let matchedLocationId = "70672580862"; // CDMX

        if (extraGuadalajaraZips.has(zip)) {
            matchedLocationId = "69200904446";
        } else {
            for (const location of locationMappings) {
                if (location.ranges.some((r) => zip >= r.from && zip <= r.to)) {
                    matchedLocationId = location.id;
                    break;
                }
            }
        }

    console.log("inventoryInfo:", window.inventoryInfo);
    console.log("api:", window.inventoryInfo?.api);
    console.log("selectLocation:", window.inventoryInfo?.api?.selectLocation);

    this.selectLocationSafe(matchedLocationId);
  };
}

customElements.define("variant-location", VariantLocation);


//Descomentar en caso de rollback

  // class VariantLocation extends HTMLElement {
  //   constructor() {
  //     super();
  //     this.container = this;
  //     this.zipCodeElements = this.container.querySelectorAll("input");
  //     this.zipValue = "";
  //     this.changeButton = this.container.querySelector(
  //       "[data-zip-change-button]",
  //     );
  //     this.zipAnnouncement = document.querySelector(".variant-location--input");
  //   }

  //   connectedCallback() {
  //     this.init();
  //     this.syncInputs();
  //   }

  //   init = () => {
  //     const storedZip = localStorage.getItem("userZipCode");
  //     const dialog = this.querySelector("dialog");

  //     if (storedZip && /^\d{5}$/.test(storedZip)) {
  //       // Si hay CP válido almacenado
  //       this.zipValue = storedZip;
  //       this.getLocationFromZip();

  //       this.zipCodeElements.forEach((input) => {
  //         input.value = "";
  //         input.placeholder = `C.P: ${storedZip}`;
  //       });

  //       this.container.setAttribute("data-cp-entered", "true");
  //       this.changeButton?.style?.setProperty("display", "inline-block");

  //       if (dialog) {
  //         dialog.removeAttribute("open"); // Asegúrate que esté cerrado
  //         dialog.setAttribute("data-variant-location", "true");
  //         dialog.setAttribute("aria-hidden", "true");
  //       }
  //     } else {
  //       // No hay CP válido => mostrar el modal
  //       if (dialog) {
  //         dialog.setAttribute("open", ""); // Mostrar modal
  //         dialog.removeAttribute("aria-hidden");
  //         dialog.removeAttribute("inert");
  //       }
  //     }
  //   };

  //   syncInputs = () => {
  //     this.zipCodeElements.forEach((input) => {
  //       input.addEventListener("input", ({ target }) => {
  //         const newValue = target.value;
  //         this.zipValue = newValue;

  //         this.zipCodeElements.forEach((el) => {
  //           if (el !== target) {
  //             el.placeholder = newValue;
  //           }
  //         });

  //         if (this.zipAnnouncement) {
  //           this.zipAnnouncement.placeholder = `C.P: ${newValue}`;
  //         }
  //       });

  //       input.addEventListener("change", ({ target }) => {
  //         const rawZip = target.value.trim();
  //         this.handleZipValueConfirmed(rawZip);
  //       });
  //     });
  //   };

  //   handleZipValueConfirmed = (rawZip) => {
  //     const closeButton = this.container.querySelector("[data-popup-close]");
  //     const sendButton = this.container.querySelector(
  //       ".variant-location__send-button",
  //     );
  //     const dialog = this.querySelector("dialog");

  //     if (rawZip.toLowerCase().startsWith("c.p")) return;

  //     if (/^\d{5}$/.test(rawZip)) {
  //       this.zipValue = rawZip;
  //       localStorage.setItem("userZipCode", rawZip);
  //       localStorage.setItem("zipFlag", "true");
  //       location.reload();
  //       this.getLocationFromZip();

  //       this.zipCodeElements.forEach((input) => {
  //         input.value = "";
  //         input.placeholder = `C.P: ${rawZip}`;
  //       });

  //       this.changeButton?.style?.setProperty("display", "inline-block");
  //       this.container.setAttribute("data-cp-entered", "true");

  //       if (dialog) {
  //         dialog.setAttribute("data-variant-location", "true");
  //       }

  //       if (closeButton && sendButton) {
  //         closeButton.style.display = "flex";
  //         closeButton.click();
  //         sendButton.setAttribute("data-popup-close", "");
  //       }
  //     } else {
  //       alert("Ingresa un código postal válido de 5 dígitos.");
  //     }
  //   };

  //   getLocationFromZip = () => {
  //     const zip = parseInt(this.zipValue.trim(), 10);
  //     if (isNaN(zip)) return;

  //       const extraGuadalajaraZips = new Set([
  //           64170,66600,66056,66000,66650,67300,67123,67250,64710,66100,67500,67350,64000,
  //           36100,36300,36436,47527,36200,36700,38260,38360,38000,36970,36960,36000,36500,
  //           38400,38800,58500,38940,38980,58840,38900,58520,58900,76008,76146,76146,76800,
  //           76500,76270,76093,76240,76950,76700,37980,76000,76750,76650,38500,37729,38943,
  //           37950,76680,61100,61250,61500,61420,61280,58312,61421,61211,58000,61600,58420,
  //           58526,61800,61820,58331,58480,59920,58880,59460,61300,58970,58920,45965,58341,
  //           61650,61252,61080,61674,60175,61658,61659,60150,60490,60460,60443,60280,60270,
  //           60250,60290,60300,60440,59972,60394,60447,60400,60404,60443,60760,61278,60500,
  //           60521,60540,60865,61760,61790,61794,61763,61769,61730,61734,60780,61770,61750,
  //           61830,61840,61745,61735,61850,61860,61868,61793,60920,60980,60886,60990,60985,
  //           60985,60982,60982,60886,60886,60987,60987,60985,60950,60955,60985,60990,60990,
  //           60990,58760,58570,58600,59430,59300,59230,59250,59730,59780,59740,59987,59980,
  //           59920,59960,59930,59010,59510,59580,59500,59711,59550,59653,59613,59120,59200,
  //           59833,59180,58701,59750,47900,59716,60619,36910,47880,58400,41614,41615,41615,
  //           40881,40883,40138,40123,40880,41614,40850,40835,40831,40831,40882,40888,40880,
  //           40888,40880,40900,40910,40900,49657,40894,40903,40908,40905,40983,40904,40904,
  //           46570,40906,40905,40914,40966,40930,45066,40025,44330,40904,40912,40936,40935,
  //           40937,40932,40960,40934,39300,39380,39340,39380,39403,39390,39406,39897,39670,
  //           39760,39770,39800,39867,39890,39799,39715,39750,39713,39905,39810,39936,39990,
  //           39360,39940,39960,39120,40970,39097,44210,45680,45640,45500,45400,20920,20000,
  //           20300,20670,20400,20460,20700,20320,20800,1239,2010,3000,4000,5000,6140,8900,
  //           9430,10500,44760,13300,14000,30200,16070,52900,55700,54700,56330,55000,56530,
  //           11610,56343,54600,54009,54960,54900,54700,55640,52760,64330,42000, 42004, 42010,
  //           42014, 42015, 42018, 42020, 42026, 42027, 42029, 42030, 42032, 42033, 42034, 42035,
  //           42036, 42037, 42039, 42040, 42050, 42055, 42056, 42057, 42058, 42060, 42064, 42070,
  //           42075, 42078, 42079, 42080, 42082, 42083
  //       ]);

  //     const locationMappings = [
  //       { id: "69200904446",
  //         ranges: [
  //           // { from: 44009, to: 45696 },
  //           { from: 44100, to: 45249 },
  //           { from: 45400, to: 45429 },
  //           { from: 45500, to: 45679 },
  //           { from: 49000, to: 49113 },
  //         ]
  //       }, // Guadalajara 44100 - 44250
  //       {
  //         id: "78100529406", // Tepic
  //         ranges: [
  //           { from: 63000, to: 63529 },
  //           { from: 63780, to: 63799 },
  //         ],
  //       },
  //     ];

  //     let matchedLocationId = "70672580862"; // CDMX

  //       if (extraGuadalajaraZips.has(zip)) {
  //           matchedLocationId = "69200904446";
  //       } else {
  //           for (const location of locationMappings) {
  //               if (location.ranges.some((r) => zip >= r.from && zip <= r.to)) {
  //                   matchedLocationId = location.id;
  //                   break;
  //               }
  //           }
  //       }
  //     window.inventoryInfo?.api?.selectLocation(matchedLocationId);
  //     console.log(`Seleccionando locationId: ${matchedLocationId}`);

  //     // const currentLocation = window.inventoryInfo?.api?.getSelectedLocation();
  //     // if (currentLocation?.id !== matchedLocationId) {
  //     //     window.inventoryInfo?.api?.selectLocation(matchedLocationId);
  //     // }

  //   };
  // }

  if (!customElements.get("variant-location")) {
    customElements.define("variant-location", VariantLocation);
  }

  class TestLocation extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.currentVariantId = this.container.getAttribute("variant-id");
      document.addEventListener(
        "theme:variant:change",
        this.handleVariantChange,
      );
      this.productHandle = this.getHandleFromUrl();
      this.input = this.container.querySelector(
        '.button-testing input[type="text"]',
      );
      this.input.addEventListener("change", this.getLocation);
    }
    getLocation = () => {
      const zipCode = this.input.value.trim();
      if (!/^\d{5}$/.test(zipCode)) {
        console.warn("Código postal inválido.");
        return;
      }
      const zip = parseInt(zipCode, 10);
      const locationMappings = [
        {
          id: "69200904446",
          ranges: [{ from: 44009, to: 45696 }],
        },
        {
          id: "78100529406",
          ranges: [
            { from: 63000, to: 63529 },
            { from: 63780, to: 63799 },
          ],
        },
      ];
      let matchedLocationId = "70672580862"; // default
      for (const location of locationMappings) {
        const found = location.ranges.some(
          (range) => zip >= range.from && zip <= range.to,
        );
        if (found) {
          matchedLocationId = location.id;
          break;
        }
      }
      console.log(`Seleccionando locationId: ${matchedLocationId}`);
      window.inventoryInfo?.api?.selectLocation(matchedLocationId);
    };

    getHandleFromUrl = () => {
      const pathname = window.location.pathname;
      const index = pathname.lastIndexOf("/") + 1;
      return pathname.substr(index);
    };
    handleVariantChange = (event) => {
      const newVariant = event.detail.variant;
      if (!newVariant || String(newVariant.id) === this.currentVariantId)
        return;

      console.log(this.input);
      this.currentVariantId = String(newVariant.id);
      // console.log("variant-location");
      // console.log(this.productHandle);
      // console.log(this.currentVariantId);
      // const apiLocation = window.inventoryInfo.api.loadApp({
      //   handle: this.productHandle,
      //   variant: this.currentVariantId,
      // });
      // console.log(apiLocation);
    };
  }

  if (!customElements.get("variant-location")) {
    customElements.define("variant-location", VariantLocation);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
